import Vue from 'vue'
import Vuex from 'vuex'
import gateways from './modules/gateways'
import meters from './modules/meters'
import user from './modules/user'
import account from './modules/account'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        gateways,
        meters,
        user,
        account
    },
})
